function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { createContext, useContext } from 'react';
import { Global } from '@emotion/react';
import { DEFAULT_THEME } from './default-theme.js';
import { mergeTheme } from './utils/merge-theme/merge-theme.js';
import { NormalizeCSS } from './NormalizeCSS.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var MantineThemeContext = createContext({
  theme: DEFAULT_THEME,
  styles: {},
  emotionOptions: {
    key: "mantine",
    prepend: true
  }
});

function useMantineTheme() {
  var _a;

  return ((_a = useContext(MantineThemeContext)) == null ? void 0 : _a.theme) || DEFAULT_THEME;
}

function useMantineThemeStyles() {
  var _a;

  return ((_a = useContext(MantineThemeContext)) == null ? void 0 : _a.styles) || {};
}

function useMantineEmotionOptions() {
  var _a;

  return ((_a = useContext(MantineThemeContext)) == null ? void 0 : _a.emotionOptions) || {
    key: "mantine",
    prepend: true
  };
}

function GlobalStyles() {
  var theme = useMantineTheme();
  return /* @__PURE__ */React.createElement(Global, {
    styles: {
      "*, *::before, *::after": {
        boxSizing: "border-box"
      },
      body: __spreadProps(__spreadValues({}, theme.fn.fontStyles()), {
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
        color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
        lineHeight: theme.lineHeight,
        fontSize: theme.fontSizes.md
      })
    }
  });
}

function MantineProvider(_ref) {
  var theme = _ref.theme,
      _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      emotionOptions = _ref.emotionOptions,
      _ref$withNormalizeCSS = _ref.withNormalizeCSS,
      withNormalizeCSS = _ref$withNormalizeCSS === void 0 ? false : _ref$withNormalizeCSS,
      _ref$withGlobalStyles = _ref.withGlobalStyles,
      withGlobalStyles = _ref$withGlobalStyles === void 0 ? false : _ref$withGlobalStyles,
      children = _ref.children;
  return /* @__PURE__ */React.createElement(MantineThemeContext.Provider, {
    value: {
      theme: mergeTheme(DEFAULT_THEME, theme),
      styles: styles,
      emotionOptions: emotionOptions
    }
  }, withNormalizeCSS && /* @__PURE__ */React.createElement(NormalizeCSS, null), withGlobalStyles && /* @__PURE__ */React.createElement(GlobalStyles, null), children);
}

MantineProvider.displayName = "@mantine/core/MantineProvider";
export { MantineProvider, useMantineEmotionOptions, useMantineTheme, useMantineThemeStyles };